import { render, staticRenderFns } from "./PolicySnapshot.vue?vue&type=template&id=db070be0&"
import script from "./PolicySnapshot.vue?vue&type=script&lang=js&"
export * from "./PolicySnapshot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../AppData/Roaming/npm/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports